import { NativeDataFetcher } from "@sitecore-jss/sitecore-jss-nextjs";
import { SchoolsResponse, School } from "../../types/school-types";

export const getSchools = async (
  lat: string,
  lng: string,
  limit: string,
  distance: string
): Promise<School[] | null> => {
  const fetcher = new NativeDataFetcher({
    headers: [["X-Api-Key", process.env.GreatSchoolsKey ?? "GreatSchoolsKey"]],
  });

  return await fetcher
    .get<SchoolsResponse>(
      `https://gs-api.greatschools.org/nearby-schools?lat=${lat}&lon=${lng}&limit=${limit}&distance=${distance}`
    )
    .then((response) => {
      if (response.data.total_count > 0) {
        return response.data.schools;
      }

      return null;
    })
    .catch((e) => {
      console.log(e);
      return null;
    });
};
